const COLORS = {
  "azul marino": "#183454",
  "azul oscuro": "#183454",
  "azul claro": "#71bce4",
  "verde oscuro": "#215c3c",
  "verde claro": "#92c969",
  "gris oscuro": "#4b5563",
  "gris claro": "#cbd5e1",
  "rojo oscuro": "#8f2536",
  blanco: "#ffffff",
  white: "#ffffff",
  negro: "#20252b",
  black: "#20252b",
  rojo: "#dc3838",
  red: "#dc3838",
  azul: "#2878cf",
  blue: "#2878cf",
  verde: "#389653",
  green: "#389653",
  amarillo: "#f5d334",
  yellow: "#f5d334",
  naranja: "#f08a2e",
  anaranjado: "#f08a2e",
  orange: "#f08a2e",
  morado: "#8753b4",
  violeta: "#8753b4",
  purple: "#8753b4",
  rosado: "#e990b7",
  rosa: "#e990b7",
  pink: "#e990b7",
  fucsia: "#cf3695",
  gris: "#939da8",
  gray: "#939da8",
  grey: "#939da8",
  plata: "#b8c2cc",
  plateado: "#b8c2cc",
  dorado: "#c4a34a",
  gold: "#c4a34a",
  cafe: "#865a3e",
  marron: "#865a3e",
  brown: "#865a3e",
  beige: "#dfcfae",
  turquesa: "#36b5b3",
  celeste: "#71bce4",
  vinotinto: "#822b45",
};
const names = Object.keys(COLORS).sort((a, b) => b.length - a.length);
export function getBikeColors(value) {
  let remaining = String(value || "")
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .trim();
  if (/^#(?:[0-9a-f]{3}|[0-9a-f]{6})$/.test(remaining)) return [remaining];
  const found = [];
  for (const name of names) {
    const pattern = new RegExp(`(^|[^a-z])${name}(?=$|[^a-z])`, "g");
    if (pattern.test(remaining)) {
      found.push({
        color: COLORS[name],
        position: remaining.search(new RegExp(`(^|[^a-z])${name}(?=$|[^a-z])`)),
      });
      remaining = remaining.replace(pattern, (match) => " ".repeat(match.length));
    }
  }
  return [
    ...new Set(found.sort((a, b) => a.position - b.position).map((item) => item.color)),
  ].slice(0, 2);
}
